// src/signup/signup.ts
import { z } from "zod";
var TeamType = /* @__PURE__ */ ((TeamType2) => {
  TeamType2["Personal"] = "personal";
  TeamType2["Team"] = "team";
  return TeamType2;
})(TeamType || {});
var TeamSize = /* @__PURE__ */ ((TeamSize2) => {
  TeamSize2["One"] = "one";
  TeamSize2["TwoToTen"] = "twoToTen";
  TeamSize2["ElevenToFifty"] = "elevenToFifty";
  TeamSize2["FiftyOnePlus"] = "fiftyOnePlus";
  return TeamSize2;
})(TeamSize || {});
var ProjectType = /* @__PURE__ */ ((ProjectType2) => {
  ProjectType2["Analytics"] = "analytics";
  ProjectType2["Defi"] = "defi";
  ProjectType2["Gaming"] = "gaming";
  ProjectType2["Wallet"] = "wallet";
  ProjectType2["Security"] = "security";
  ProjectType2["Social"] = "social";
  ProjectType2["Marketplace"] = "marketplace";
  ProjectType2["InfraAndTooling"] = "infraAndTooling";
  ProjectType2["NFTs"] = "nfts";
  ProjectType2["Identity"] = "identity";
  return ProjectType2;
})(ProjectType || {});
var ProjectSegment = /* @__PURE__ */ ((ProjectSegment2) => {
  ProjectSegment2["New"] = "new";
  ProjectSegment2["Existing"] = "existing";
  ProjectSegment2["Explorer"] = "explorer";
  return ProjectSegment2;
})(ProjectSegment || {});
var SignupOptions = z.object({
  project_type: z.union([z.nativeEnum(ProjectType), z.string()]),
  project_segment: z.nativeEnum(ProjectSegment).nullable(),
  team_type: z.nativeEnum(TeamType).or(z.literal("")),
  team_size: z.nativeEnum(TeamSize).nullable(),
  chains: z.string(),
  other_chains: z.string().nullable(),
  enterprise_project_details: z.string().nullable()
});
var SetupStage = /* @__PURE__ */ ((SetupStage2) => {
  SetupStage2[SetupStage2["COMPLETE"] = 0] = "COMPLETE";
  SetupStage2[SetupStage2["CREATED"] = 1] = "CREATED";
  SetupStage2[SetupStage2["QUERYING"] = 2] = "QUERYING";
  SetupStage2[SetupStage2["CELEBRATING"] = 3] = "CELEBRATING";
  SetupStage2[SetupStage2["INVITING_TEAM"] = 4] = "INVITING_TEAM";
  SetupStage2[SetupStage2["BILLING"] = 5] = "BILLING";
  return SetupStage2;
})(SetupStage || {});

export {
  TeamType,
  TeamSize,
  ProjectType,
  ProjectSegment,
  SignupOptions,
  SetupStage
};
//# sourceMappingURL=chunk-PXFHUXK4.mjs.map